<template>
	<sideNav :page-title="pageTitle"></sideNav>
	<div class="ld-panel-title">
		<h2 class="back-btn">站内信管理</h2>
	</div>
	<div class="ld-panel-main">
		<el-button type="primary" class="add" @click="selectReadChange('batch')">标记选中为已读</el-button>
		<el-button type="primary" plain class="add" @click="selectReadChange('all')">标记全部为已读</el-button>
		<div class="input-select" style="margin-left: 12px;">
			<el-input
			  v-model="sTitle"
			  placeholder="请输入搜索关键词..."
			  class="input-with-select"
			  clearable 
			  @clear="handleEmpty"
			  style="width: 400px;"
			>
			  <template #prepend>
				<el-select v-model="sDate" placeholder="操作时间" style="width: 100px">
				  <el-option label="操作时间" value="0" />
				  <el-option label="当天提醒" value="1" />
				  <el-option label="7天内提醒" value="7" />
				  <el-option label="15天内提醒" value="15" />
				  <el-option label="30天内提醒" value="30" />
				</el-select>
			  </template>
			  <template #append>
			  	<el-button @click="searchClick"></el-button>
			  </template>
			</el-input>
		</div>
		<el-tabs v-model="activeName" class="demo-tabs" @tab-click="handleClick">
			<el-tab-pane label="全部消息" name="0">
				<el-table :data="tableData" v-loading="loading" style="width: 100%" @selection-change="handleSelectionChange">
					<el-table-column type="selection" width="60" />
					<el-table-column prop="id" label="编号" />
					<el-table-column prop="title" label="标题" />
					<el-table-column prop="date" label="时间" />
					<el-table-column label="状态">
						<template #default="scope">
							<el-text v-if="scope.row.state == '已读'">{{scope.row.state}}</el-text>
							<el-text type="danger" v-else>{{scope.row.state}}</el-text>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="90">
					  <template #default="scope">
						<el-button type="primary" size="small" link @click="rowOperation(scope.row)">查看详情</el-button>
					  </template>
					</el-table-column>
				</el-table>
			</el-tab-pane>
			<el-tab-pane label="未读消息" name="1">
				<el-table :data="tableData" v-loading="loading" style="width: 100%" @selection-change="handleSelectionChange">
					<el-table-column type="selection" width="30" />
					<el-table-column prop="id" label="编号" />
					<el-table-column prop="title" label="标题" />
					<el-table-column prop="date" label="时间" />
					<el-table-column label="状态">
						<template #default="scope">
							<el-text v-if="scope.row.state == '已读'">{{scope.row.state}}</el-text>
							<el-text type="danger" v-else>{{scope.row.state}}</el-text>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="90">
					  <template #default="scope">
						<el-button type="primary" size="small" link @click="rowOperation(scope.row)">查看详情</el-button>
					  </template>
					</el-table-column>
				</el-table>
			</el-tab-pane>
			<el-tab-pane label="已读消息" name="2">
				<el-table :data="tableData" v-loading="loading" style="width: 100%" @selection-change="handleSelectionChange">
					<el-table-column type="selection" width="30" />
					<el-table-column prop="id" label="编号" />
					<el-table-column prop="title" label="标题" />
					<el-table-column prop="date" label="时间" />
					<el-table-column label="状态">
						<template #default="scope">
							<el-text v-if="scope.row.state == '已读'">{{scope.row.state}}</el-text>
							<el-text type="danger" v-else>{{scope.row.state}}</el-text>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="90">
					  <template #default="scope">
						<el-button type="primary" size="small" link @click="rowOperation(scope.row)">查看详情</el-button>
					  </template>
					</el-table-column>
				</el-table>
			</el-tab-pane>
		</el-tabs>
		<pageList :pagination="pagination" :paginationTotal="paginationTotal" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange"></pageList>
	</div>
	<!-- 详情 -->
	<el-drawer v-model="drawer" title="网站应用详情" size="45%">
		<el-descriptions border :column="1">
			<el-descriptions-item label="发布时间">{{drawerData.date}}</el-descriptions-item>
			<el-descriptions-item label="标题"><el-text type="primary">{{drawerData.title}}</el-text></el-descriptions-item>
			<el-descriptions-item label="内容"><span v-html="drawerData.info"></span></el-descriptions-item>
		</el-descriptions>
	</el-drawer>
</template>

<script setup>
	import { ref,reactive,onMounted} from 'vue';
	import pageList from '../../components/pageList.vue';
	import sideNav from '../../components/sideNav.vue';
	import { siteMassage,siteMassageMark } from '@/api/account';
	import { ElMessage, ElMessageBox } from 'element-plus';
	import { Search } from '@element-plus/icons-vue';
	
	const pageTitle = 'account';
	const activeName = ref('0');
	const sDate = ref('0');
	const sTitle = ref('');
	const selectIds = ref();
	const drawer = ref(false);
	const drawerData = ref('');
	const pagination = reactive({page: 1,size: 15});
	const paginationTotal = ref(0);
	const loading = ref();
	const tableData = ref();
	
	const fetchListF = () => {
		const param = {
			'page':pagination.page,
			'pageSize':pagination.size,
			'type':parseInt(activeName.value),
			'days':parseInt(sDate.value),
			'title':sTitle.value
		}
		siteMassage(param).then((res) => {
			tableData.value = res.data.list;
			paginationTotal.value = res.data.total;
			loading.value = false
		})
	}
	const handleClick = (tab, event) => {
		activeName.value = tab.props.name;
		fetchListF()
	}
	const handleSelectionChange = (val) => {
		selectIds.value = val.map(item =>item.id)
	};
	const selectReadChange = (val) => {
		const param = {'type':val,'ids':selectIds.value}
		siteMassageMark(param).then((res) => {
			if(res.code === 200){
				ElMessage({
					offset:70,
					message: res.msg,
					type: 'success'
				})
				fetchListF()
			}
		})
	}
	const rowOperation = (item) => {
		drawer.value = !drawer.value;
		drawerData.value = item;
		const param = {'type':'batch','ids':[item.id]}
		siteMassageMark(param).then((res) => {
			if(res.code === 200){
				fetchListF()
			}
		})
	}
	const searchClick = () => {
		fetchListF();
	};
	const handleEmpty = () => {
		fetchListF();
	};
	const handleCurrentChange = (e) => {
		pagination.page = e;
		fetchListF()
	};
	const handleSizeChange = (e) => {
		pagination.size = e;
		fetchListF()
	};
	
	onMounted(() => {
		fetchListF()
	});
</script>

<style scoped>
	::v-deep(.el-descriptions__label) {width: 100px !important;}
	
</style>